import { initHeader } from "@advice/apps/initHeader";
import { initJobsSidebar } from "@advice/apps/initJobsSidebar";
import { JWPlayerVideos } from "@advice/apps/initJWPlayerVideos";
import { IArticleProps } from "@advice/pages/article/Article";
import { IWriter } from "@advice/pages/writer/Writer";
import { IConfig } from "@server/server";
import { addPropsToLegacyRoundups } from "@util/addPropsToLegacyRoundups";
import { initOskarTriggers } from "@util/initOskarTriggers";

import { ILandingProps } from "./pages/landing/Landing";

// We will be extending this interface beyond article
// props in the future, and this make the type easier
// to maintain until then.
export interface IAdviceInitialState extends IArticleProps {
    templateName: string;
    href: string;
    referrer: string;
    config: IConfig;
    search: string;
    pathname: string;
}

export interface IWriterInitialState extends IWriter {
    config: IConfig;
    href: string;
    pathname: string;
    referrer: string;
    search: string;
    templateName: string;
}

export interface ILandingInitialState extends ILandingProps {
    templateName: string;
    href: string;
    referrer: string;
    config: IConfig;
    search: string;
    pathname: string;
}

export interface AdviceWindow extends Window {
    __MUSE__: {
        initialState: IAdviceInitialState | IWriterInitialState | ILandingInitialState;
    };
}

declare const window: AdviceWindow;

document.addEventListener("DOMContentLoaded", async () => {
    const initialState = window.__MUSE__.initialState;
    await initHeader(initialState);
    await addPropsToLegacyRoundups();
    await initJobsSidebar();
    await initOskarTriggers();
    const jwPlayerID = ((initialState || {}).config || {}).jwPlayerID;
    if (jwPlayerID) {
        try {
            JWPlayerVideos.initJWPlayerVideos(jwPlayerID);
        } catch (error) {
            console.error("Could not initialize JWPlayer Videos: ", error);
        }
    }
});
